import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, Typography } from '@mui/material';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import SportsHandballIcon from '@mui/icons-material/SportsHandball';
import SportsCricketIcon from '@mui/icons-material/SportsCricket';
import { toSportSlug } from '@utils/sports';

const contests = [
  {
    title: 'Football',
    description: 'Passing, shooting and ball control — enter Developmental & Performance contest skills for your age group.',
    icon: <SportsSoccerIcon />,
    color: '#22c55e',
  },
  {
    title: 'Badminton',
    description: 'Smashes, net play and rally skills — enter Developmental & Performance contest skills for your age group.',
    icon: <SportsHandballIcon />,
    color: '#38bdf8',
  },
  {
    title: 'Cricket',
    description: 'Batting, bowling and fielding — enter Developmental & Performance contest skills for your age group.',
    icon: <SportsCricketIcon />,
    color: '#fbbf24',
  },
];

const LandingFoundationContestSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        p: { xs: 3.5, md: 5 },
        borderRadius: 4,
        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1d4ed8 100%)',
        color: '#fff',
        boxShadow: '0 24px 64px rgba(15, 23, 42, 0.25)',
      }}
    >
      <Typography
        sx={{
          fontFamily: '"Sora", Arial, sans-serif',
          fontWeight: 800,
          mb: 1,
          textAlign: 'center',
          fontSize: { xs: '1.7rem', md: '2.25rem' },
        }}
      >
        Developmental & Performance Contest
      </Typography>
      <Typography
        sx={{
          textAlign: 'center',
          color: 'rgba(255,255,255,0.86)',
          mb: 4,
          maxWidth: 680,
          mx: 'auto',
          fontSize: { xs: '1.05rem', md: '1.2rem' },
          lineHeight: 1.55,
        }}
      >
        Open contests for Football, Badminton and Cricket. Pick a sport and participate.
      </Typography>

      <Grid container spacing={2.5}>
        {contests.map((contest) => (
          <Grid item xs={12} sm={6} md={4} key={contest.title}>
            <Box
              sx={{
                p: { xs: 2.5, md: 3 },
                height: '100%',
                borderRadius: 2.5,
                bgcolor: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.12)',
                backdropFilter: 'blur(8px)',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Box sx={{ color: contest.color, mb: 1.25, display: 'flex', '& svg': { fontSize: 36 } }}>
                {contest.icon}
              </Box>
              <Typography
                sx={{
                  fontFamily: '"Sora", Arial, sans-serif',
                  fontWeight: 800,
                  mb: 0.75,
                  fontSize: { xs: '1.2rem', md: '1.35rem' },
                }}
              >
                {contest.title}
              </Typography>
              <Typography
                sx={{
                  color: 'rgba(255,255,255,0.8)',
                  mb: 2.5,
                  minHeight: 48,
                  flex: 1,
                  fontSize: { xs: '0.98rem', md: '1.05rem' },
                  lineHeight: 1.55,
                }}
              >
                {contest.description}
              </Typography>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => navigate(`/contests/${toSportSlug(contest.title)}`)}
                sx={{
                  textTransform: 'none',
                  fontWeight: 700,
                  fontSize: '1rem',
                  py: 1,
                  fontFamily: '"Sora", Arial, sans-serif',
                  color: '#fff',
                  borderColor: 'rgba(255,255,255,0.35)',
                  '&:hover': { borderColor: '#fff', bgcolor: 'rgba(255,255,255,0.1)' },
                }}
              >
                Participate
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LandingFoundationContestSection;
